import { useMutation } from "@tanstack/react-query";
import { useContext } from "react";
import { AlertBannerContext } from "@kivunova/kivufrontendcommon";
import { fetchGraphQL } from "../../Graphql/utils";
import {
  listFeaturesQuery,
  getFeatureQuery,
  getPlanFeaturesQuery,
  createFeatureMutation,
  updateFeatureMutation,
  addPlanFeatureMutation,
  deletePlanFeatureMutation,
} from "../../Graphql/querries/featureQuery";
import {
  ListFeaturesResponse,
  GetFeatureResponse,
  GetPlanFeaturesResponse,
  CreateFeatureResponse,
  UpdateFeatureResponse,
  AddPlanFeatureResponse,
  DeletePlanFeatureResponse,
  ListFeaturesInput,
  GetFeatureInput,
  GetPlanFeaturesInput,
  CreateFeatureInput,
  UpdateFeatureInput,
  AddPlanFeatureInput,
} from "../../Graphql/types/feature";

export const useGetFeatureList = () => {
  const { setAlert } = useContext(AlertBannerContext);

  return useMutation<ListFeaturesResponse, Error, ListFeaturesInput | void>({
    mutationKey: ["listFeatures"],
    mutationFn: (input) =>
      fetchGraphQL(listFeaturesQuery, { input: input ?? {} }, setAlert),
  });
};

export const useGetFeatureDetail = () => {
  const { setAlert } = useContext(AlertBannerContext);

  return useMutation<GetFeatureResponse, Error, GetFeatureInput>({
    mutationKey: ["getFeature"],
    mutationFn: (input) => fetchGraphQL(getFeatureQuery, { input }, setAlert),
  });
};

export const useCreateFeature = () => {
  const { setAlert } = useContext(AlertBannerContext);

  return useMutation<CreateFeatureResponse, Error, CreateFeatureInput>({
    mutationKey: ["createFeature"],
    mutationFn: (input) =>
      fetchGraphQL(createFeatureMutation, { input }, setAlert),
  });
};

export const useGetPlanFeatures = () => {
  const { setAlert } = useContext(AlertBannerContext);

  return useMutation<GetPlanFeaturesResponse, Error, GetPlanFeaturesInput>({
    mutationKey: ["getPlanFeatures"],
    mutationFn: (input) =>
      fetchGraphQL(getPlanFeaturesQuery, { input }, setAlert),
  });
};

export const useUpdateFeature = () => {
  const { setAlert } = useContext(AlertBannerContext);

  return useMutation<
    UpdateFeatureResponse,
    Error,
    { featureCode: string; input: UpdateFeatureInput }
  >({
    mutationKey: ["updateFeature"],
    mutationFn: ({ featureCode, input }) =>
      fetchGraphQL(updateFeatureMutation, { featureCode, input }, setAlert),
  });
};

export const useAddPlanFeature = () => {
  const { setAlert } = useContext(AlertBannerContext);

  return useMutation<AddPlanFeatureResponse, Error, AddPlanFeatureInput>({
    mutationKey: ["addPlanFeature"],
    mutationFn: (input) =>
      fetchGraphQL(addPlanFeatureMutation, { input }, setAlert),
  });
};

export const useDeletePlanFeature = () => {
  const { setAlert } = useContext(AlertBannerContext);

  return useMutation<
    DeletePlanFeatureResponse,
    Error,
    { planId: string; featureCode: string }
  >({
    mutationKey: ["deletePlanFeature"],
    mutationFn: ({ planId, featureCode }) =>
      fetchGraphQL(
        deletePlanFeatureMutation,
        { planId, featureCode },
        setAlert,
      ),
  });
};
